export default {
  name: 'qrcodeExpired',
  type: 'layout',
  active: false,
  data: {
    isActive: false,
    day: 1,
  }
}
